const sessionKey = "superlive-lastp";
const sessionPageKey = "superlive-pageName";

/**
 * 设置上个页面的cntp
 * @param {String} cntp
 */
export const setLastp = (cntp) => {
  window.sessionStorage.setItem(sessionKey, cntp);
};

/**
 * 获取上个页面的cntp
 * @returns {String}
 */
export const getLastp = () => {
  return window.sessionStorage.getItem(sessionKey) || "";
};

/**
 * 设置页面的pageName
 * @param {String} pageName
 */
export const setPageName = (pageName) => {
  window.sessionStorage.setItem(sessionPageKey, pageName);
};

/**
 * 获取页面的pageName
 * @returns {String}
 */
export const getPageName = () => {
  return window.sessionStorage.getItem(sessionPageKey) || "";
};
